const coldEmail = {
  sending: {
    status: {
      normal: '正常',
      warmup: '预热中',
      throttled: '已降速',
      paused: '已暂停',
      unavailable: '发送状态暂不可用',
    },
    provider: {
      workspace: 'Google Workspace',
      m365: 'Microsoft 365',
      gmail: '个人 Gmail',
      other: '其他企业邮',
    },
    dailyLimit: '每日上限',
    usage: '滚动 24 小时已发 / 上限',
    senderPool: '发件邮箱',
    selectMailbox: '请至少选择一个发件邮箱',
    saveLimit: '保存上限',
    limitSaved: '邮箱每日上限已更新',
    poolSaved: '发件邮箱已更新',
    missingMailbox: '原发件邮箱已删除或不可用，请移除后选择可用邮箱。',
    removeMissingMailbox: '移除',
    repairPoolTitle: '更新发件邮箱',
    repairPoolConfirm:
      '以下步骤的指定邮箱不在新的邮箱池中：{steps}。保存后这些步骤将改为自动选择邮箱，未保存的正文编辑会保留。已停止的人选不会自动恢复发送。',
    estimate: '预计 {days} 天发完',
    estimatePaused: '发件邮箱暂停中',
    estimateUnavailable: '暂时无法预估，请稍后重试',
    bind: {
      warmupTip: '新邮箱需要 14 天预热来建立信誉，这期间发送量较低是正常的。',
      gmailTip: '个人 Gmail 适合低频测试。建议使用 Google Workspace 自定义域名，投递率更好。',
      primaryDomainTip: '如果这是公司官网正在使用的域名，建议另注册一个二级域名专门发冷邮件。',
      ok: '知道了',
      title: '发件邮箱已绑定',
    },
  },
  title: '冷邮件任务',
  subtitle: '使用已绑定的发件邮箱发送个性化外联邮件',
  createNew: '新建任务',
  metricsAria: '任务汇总',
  metrics: {
    currentPageRecipients: '当前页收件邮箱',
    currentPageAccepted: '当前页 SMTP 已接受',
    currentPageFailed: '当前页发送失败',
    currentPageRunning: '当前页运行中任务',
  },
  views: {
    list: '任务列表',
    edit: '编辑序列',
    log: '发送日志',
    set: '外联设置',
  },
  sources: {
    tag: '人才库标签',
    agent: '岗位人才 · Agent',
    rec: '人才推荐',
  },
  sourceFilters: {
    selected: '已选 {count} 项',

    advanced: '高级选项',
    connection: '候选人连接状态',
    pipeline: '岗位人选阶段',
    unrestricted: '不限状态',
    hint: '可多选，不选择则不限状态。仅在导入时筛选。',
    matched: '筛选匹配 {count} 人',
    countHint: '实际导入会排除无邮箱或被去重规则跳过的人选。',
    loading: '正在计算匹配人数…',
    failed: '匹配人数加载失败，请重试',
    empty: '没有匹配的人选，请调整来源或状态',
    states: { Added: '已添加', Pending: '待通过', NotSent: '未添加' },
    stages: {
      Submitted: '筛选中',
      Screening: '沟通中',
      Recommended: '推荐中',
      Interview: '面试环节',
      Offer: 'Offer 谈判',
      PreOnboarding: 'Offer 待入职',
      Onboarded: '人才到岗',
    },
  },
  sequence: {
    panelTitle: '冷邮件序列',
    addStep: '添加邮件',
    clearSteps: '清空',
    emptySteps: '还没有邮件，点下方添加',
    saveBeforeStart: '请先保存邮件序列，再开始发送',
    saved: '已保存',
    modified: '序列已修改',
    saveSequence: '保存',
    noCampaignToSave: '当前没有可保存的外联任务，请先创建任务',
    templates: '邮件模板',
    switchTemplate: '切换模板',
    currentSequenceSaved: '当前邮件序列已保存',
    unsavedChangesTitle: '当前有未保存的修改',
    unsavedChangesDesc: '您当前编辑的内容尚未保存，离开后未保存的修改将会丢失。确定要离开吗？',
    continueEditing: '继续编辑',
    discardAndLeave: '放弃修改并离开',
    saveAndLeave: '保存并离开',
    inboxReplies: '站内信回复',
    senderNoticeTitle: '发件邮箱',
    senderNoticeDesc: '已绑定 {count} 个发件邮箱，按配额自动轮换发送',
    bindGmail: '绑定 Gmail',
    configSmtp: '配置 SMTP',
    candidatePreviewTitle: '候选人预览',
    candidatePreviewDesc: '按真实数据预览变量替换效果',
    candidateSearchPlaceholder: '搜索姓名、职位或邮箱',
    candidateListHeading: '可预览候选人（{count}）',
    candidatePreviewPosition: '{current} / {total}',
    previousCandidate: '上一个候选人',
    nextCandidate: '下一个候选人',
    noCandidatesFound: '没有匹配的候选人',
    loadingCandidates: '正在加载候选人…',
    loadMoreCandidates: '加载更多候选人',
    noCandidatePreview: '暂无可预览的候选人',
    candidateActions: '候选人操作',
    stopCandidate: '停止该候选人外联',
    resumeCandidate: '恢复该候选人外联',
    removeCandidate: '从任务中移除候选人',
    removeCandidateConfirm: '确定要将「{name}」从当前任务中移除吗？',
    candidateStoppedToast: '已停止该候选人的外联',
    candidateResumedToast: '已恢复该候选人的外联',
    candidateRemovedToast: '候选人已从任务中移除',
    aiPlaceholder: '让 Agent 帮你增删或改写邮件步骤，例如：再加一封 5 天后的跟进',
    stepNumber: '第 {num} 封：{name}',
    stepPrefix: '第 {num} 封：',
    dayOf: 'Day {day}',
    waitDays: '等待 {days} 天',
    candidateCount: '{count} 位候选人',
    decreaseDays: '减少等待天数',
    increaseDays: '增加等待天数',
    autoRotate: '自动轮换（{count} 个邮箱）',
    senderPicker: '发件',
    noSenderConfigured: '未配置发件邮箱',
    subject: '主题',
    modeAi: 'AI 撰写',
    modeManual: '手动编辑',
    preview: '预览',
    previewAll: '预览全部',
    editAll: '编辑全部',
    previewAllHint: '当前候选人的首封及全部跟进邮件',
    selectCandidatesBeforeStart: '请先选择来源和状态并导入候选人，再开始发送',
    edit: '编辑',
    aiNote: '发送前由 AI 按候选人背景改写这封邮件，下面是基准内容',
    regen: '重新生成',
    loadTemplate: '载入模板',
    editTemplate: '编辑模板',
    templateEditing: '模板编辑中',
    templateEditingBanner: '正在编辑模板「{name}」，不会修改当前外联任务',
    saveTemplate: '保存模板',
    exitTemplateEdit: '退出模板编辑',
    systemTemplateReadOnly: '系统模板不可修改',
    templateNameRequired: '模板名称不能为空',
    templateSavedToast: '模板「{name}」已保存',
    templateEditRequiresSavedCampaign: '请先保存当前任务，再编辑模板',
    templateDiscardConfirm: '模板还有未保存修改，确定退出吗？',
    templatePickerDescription: '选择后将替换当前序列步骤',
    loadingTemplates: '加载中...',
    noTemplates: '暂无可用模板',
    templateStepCount: '{count} 步',
    createTemplate: '新建模板',
    createTemplateTitle: '新建冷邮件模板',
    createTemplateDescription: '将当前序列的 {count} 个步骤保存为可复用模板。',
    templateNameLabel: '模板名称',
    templateNamePlaceholder: '例如：AI 工程师候选人首轮触达',
    templateCreatedToast: '模板「{name}」已创建',
    templateCreateFailed: '模板创建失败，请稍后重试',
    templateRequiresSteps: '当前序列还没有邮件步骤，无法创建模板',
    deleteTemplate: '删除模板',
    deleteTemplateTitle: '删除序列模板',
    deleteTemplateConfirm: '确定删除模板「{name}」吗？删除后不可恢复。',
    templateDeletedToast: '模板「{name}」已删除',
    templateLoadFailed: '模板加载失败，请稍后重试',
    templateDeleteFailed: '模板删除失败，请稍后重试',
    templateSaveFailed: '模板保存失败，请稍后重试',
    templateManagerTitle: '冷邮件模板',
    templateManagerListTitle: '模板列表',
    templateManagerDescription: '集中管理可复用的多步骤冷邮件序列模板。',
    templateManagerCreate: '新建模板',
    templateManagerCreateTitle: '新建冷邮件模板',
    templateManagerCreateDescription: '创建后可继续编辑每一步的主题、正文和发送规则。',
    templateManagerEdit: '编辑冷邮件模板',
    templateManagerReadOnly: '查看系统模板',
    templateManagerSelect: '选择一个冷邮件模板开始编辑',
    templateManagerEmpty: '暂无冷邮件模板',
    templateManagerName: '模板名称',
    templateManagerSteps: '邮件步骤',
    templateManagerStepHint: '调整步骤顺序、等待天数和每封邮件的发送内容。',
    templateManagerAddStep: '添加步骤',
    templateManagerSave: '保存更改',
    templateManagerCancel: '撤销修改',
    templateManagerMoveUp: '上移',
    templateManagerMoveDown: '下移',
    templateManagerDiscardConfirm: '当前模板有未保存修改，确定切换吗？',
    templateStepNameLabel: '第 {index} 步名称',
    systemTemplate: '系统',
    customSender: '指定发件邮箱',
    waitDaysLabel: '等待天数',
    bodyLabel: '邮件正文',
    sendPreviewToMe: '发送预览到我的邮箱',
    sameThread: '同一邮件会话',
    stopOnReply: '回复后停止后续',
    deleteStep: '删除',
    undo: '撤销',
    sequenceSavedToast: '序列已保存',
    stepDeletedToast: '已删除「{name}」',
    stepAddedToast: '已添加第 {num} 封邮件',
    aiGeneratedToast: '已新增一封 AI 跟进邮件',
    clearedToast: '已清空所有邮件',
    orderAdjustedToast: '顺序已调整，间隔天数保持不变',
    previewSentToast: '已把「{name}」的预览发送到当前发件邮箱',
    aiRegenToast: 'AI 已按候选人背景重新生成这封邮件',
    aiRewritePrompt: '改写{name}，使其更具吸引力并符合岗位要求',
    aiRewriteFailed: 'AI 改写失败',
    modeAiToast: '这封邮件将由 AI 按候选人背景个性化改写',
    modeManualToast: '这封邮件将按基准模版原样发送',
  },
  taskList: {
    filterAll: '全部',
    filterRunning: '运行中',
    filterPaused: '已暂停',
    filterDone: '已完成',
    filterDraft: '草稿',
    filterArchived: '已归档',
    searchPlaceholder: '搜索任务 / 岗位 / 来源',
    noMatchingTasks: '没有符合条件的任务',
    colTask: '任务',
    colSource: '来源',
    colProgress: '进度',
    colReply: '回复',
    colStatus: '状态',
    colCreated: '创建',
    colAction: '操作',
    editSequence: '编辑序列',
    stepCount: '{count} 封邮件',
    toInbox: '去站内信',
    repliesCount: '{count} 条',
    sentProgress: '已发 {sent} / {total}',
    failedCount: '失败 {count}',
    dedupTip:
      '同一候选人不会被两个运行中的任务同时触达：新建任务时自动跳过，并可排除 90 天内已发过的人。',
    menuViewLogs: '查看发送日志',
    menuCopyTask: '复制为新任务',
    menuSaveAsTpl: '保存为序列模板',
    taskTemplateName: '{name} 模板',
    menuToggleStatus: '暂停 / 启用任务',
    menuArchive: '归档任务',
    menuUnarchive: '取消归档',
    menuDelete: '永久删除任务',
    deleteTitle: '永久删除外联任务',
    deleteConfirm:
      '确定永久删除「{name}」吗？任务、步骤、候选人队列和发送日志都会被删除，且无法恢复。',
    taskArchivedToast: '已归档「{name}」',
    taskUnarchivedToast: '已取消归档「{name}」，任务已恢复为草稿',
    taskDeletedToast: '已永久删除「{name}」',
    taskSavedTplToast: '已把「{name}」的 {count} 封邮件保存为序列模板',
    taskToggledRunningToast: '任务已启用',
    taskToggledPausedToast: '任务已暂停，进行中的候选人停在当前这封',
  },
  settings: {
    title: '外联设置',
    candidateSource: '候选人来源',
    talentTag: '人才标签',
    enrolledCount: '已加入',
    enrolledDetail: '进行中 {active} · 已停止 {stopped}',
    enrolledPeople: '{count} 位',
    senderAccountsTitle: '发件邮箱（按额度轮换）',
    rateLimitValue: '{count} 封 / {minutes} 分钟',
    rateLimitLabel: '每个发件邮箱额度',
    rateLimitScopeHint: '此额度分别作用于每个发件邮箱；任务内多个邮箱各自独立计算。',
    saveRateLimit: '保存额度',
    rateLimitSavedToast: '每邮箱发送额度已保存',
    noSenderAccounts: '暂无已绑定的发件邮箱',
    manageSenders: '管理发件邮箱',
    stopRulesTitle: '停止规则',
    ruleStopOnReply: '候选人回复后停止后续邮件',
    ruleStopOnJobApplied: '已加入岗位人才后停止',
    rulesSavedToast: '停止规则已保存',
    readOnlyHint: '已完成或已归档的任务仅供查看。需要修改时，请复制为新任务。',
  },
  logs: {
    title: '发送日志',
    totalSummary: '共 {total} 条 · 失败 {failed}',
    colCandidate: '候选人',
    colStep: '邮件步骤',
    colSenderEmail: '发件邮箱',
    colTime: '时间',
    colStatus: '状态',
    colAction: '操作',
    viewInInbox: '在站内信查看',
    retry: '重试',
    retrySuccess: '已重新加入发送队列',
    loadMore: '加载更多日志',
    loadingMore: '加载中…',
    statusSmtpOk: 'SMTP 已接受',
    statusFail: '发送失败',
    statusReply: '已回复',
    statusQueued: '待发送',
    allSenderEmails: '全部发件邮箱',
  },
  dialogs: {
    newTaskTitle: '新建冷邮件任务',
    newTaskDesc: '从人才库标签、Agent 匹配的岗位人才或人才推荐里选一批人，套用一套邮件序列。',
    taskNameLabel: '任务名称',
    taskNamePlaceholder: '例如：Go 后端 · 冷邮件 09-16',
    candidateSourceLabel: '候选人来源',
    sourceOptionCount: '{name}（{count} 人）',
    loading: '加载中...',
    sourceLoadFailed: '来源加载失败，请重试',
    selectCandidateSource: '请选择候选人来源',
    noAvailableSources: '暂无可用来源',
    sequenceTemplateLabel: '邮件序列',
    selectSequenceTemplate: '请选择序列模板',
    blankSequence: '空白序列',
    autoTaskNameSuffix: ' · 冷邮件',
    dedupLabel: '去重设置',
    dedup90Days: '排除 90 天内已发过的候选人',
    dedupActive: '排除已在其他运行中任务里的候选人',
    cancel: '取消',
    createAndEdit: '创建并编辑序列',
    createdToast: '任务已创建',
    createdAndEnrolledToast:
      '任务已创建，已导入 {enrolled} 位候选人，跳过 {skipped} 位，可编辑序列后再开始发送',
    noCandidatesEnrolledToast:
      '这次没有任何候选人成功导入任务（不是任务创建失败）。可能原因包括：缺少简历、无有效邮箱、命中 90 天去重、正在其他任务中，或已导入当前任务。',
    enrollTitle: '加入候选人',
    enrollDesc: '候选人从第 1 封开始按天推进；回复后自动停止后续邮件，回复统一进站内信。',
    enrollSourceLabel: '来源',
    rateLimitLabel: '每个邮箱发送量 / 时间窗口',
    rateLimitUnitCount: '封 /',
    rateLimitUnitMinutes: '分钟',
    enrollAndStart: '加入并开始发送',
    enrolledToast: '已加入候选人，首封邮件按额度开始发送',
  },
  creator: {
    title: '创建任务',
    talentTag: '人才标签',
    selectTag: '选择标签',
    senderEmail: '发件邮箱',
    selectSenderEmail: '选择发件邮箱',
    configureSenderEmail: '配置发件邮箱',
    perMailboxLimit: '每个邮箱发送量',
    windowMinutes: '时间窗口（分钟）',
    selectedSenderCount: '已选 {selected} / {total} 个发件邮箱',
    rateLimitHint: '每个发件邮箱在 {window} 分钟内最多发送 {count} 封，超出后自动等待下个窗口',
    emailContent: '邮件内容',
    useTemplate: '使用模板',
    customContent: '临时正文',
    selectTemplate: '选择邮件模板',
    subjectPlaceholder: '邮件主题',
    placeholderLabel: '变量',
    placeholderExample: '发送时按候选人信息替换',
  },
  placeholders: {
    name: '候选人姓名',
    role: '职位',
    location: '所在地',
    summary: '个人简介',
  },
  recipients: {
    title: '收件邮箱',
    previewSummary: '{candidates} 人 · {emails} 个邮箱',
    reload: '重新获取',
    selectRecommended: '默认选择',
    selectAll: '全选未发送',
    clearSelection: '清空',
    emptySelectTag: '请选择人才标签',
    unnamedCandidate: '未命名候选人',
    previouslySent: '历史已发',
    createAndSend: '创建任务并开始发送',
  },
  counts: {
    emails: '{count} 个邮箱',
    previouslySent: '{count} 个历史已发',
  },
  pagination: '共 {total} 条，第 {page} / {pages} 页',
  workspace: {
    campaignBoard: '任务看板',
    sendLogs: '发送日志',
  },
  status: {
    all: '全部状态',
    running: '运行中',
    paused: '已暂停',
    completed: '已完成',
    archived: '已归档',
    canceled: '已取消',
    pending: '待发',
    sending: '发送中',
    waiting: '等待发送',
    smtpAccepted: 'SMTP 已接受',
    failed: '失败',
    sendFailed: '发送失败',
    returned: '已退回',
    draft: '草稿',
  },
  table: {
    task: '任务',
    tagTask: '标签任务',
    status: '状态',
    progress: '处理进度',
    progressSummary: '{sent} 已发 · {failed} 失败 · {pending} 待发',
    senderEmail: '发件邮箱',
    recipientEmail: '收件邮箱',
    estimatedFinish: '预计完成',
    time: '时间',
    subject: '主题',
    error: '错误',
    candidate: '候选人',
    senderWindow: '窗口 {used}/{limit}',
  },
  actions: {
    refresh: '刷新',
    retry: '重试',
    detail: '详情',
    pause: '暂停',
    resume: '启用',
    startSending: '开始发送',
    cancel: '取消',
    enrollCandidates: '加入候选人',
    outreachSettings: '外联设置',
    backToList: '冷邮件任务',
  },
  detail: {
    title: '任务详情',
    total: '总数',
    senderQuota: '发件邮箱额度',
    availableNow: '当前可发',
    nextAvailableAt: '下次可发 {time}',
    recipientDetails: '收件明细',
  },
  remaining: {
    waitingSchedule: '等待调度',
    minutes: '约 {minutes} 分钟',
    hours: '约 {hours} 小时',
    hoursMinutes: '约 {hours} 小时 {minutes} 分',
  },
  messages: {
    created: '任务已创建，共 {count} 个收件邮箱',
    selectTaskFirst: '请先在任务列表中选择一个冷邮件任务',
    loadFailed: '最新数据加载失败，请重试。',
    actionFailed: '操作失败，请重试。',
    paused: '任务已暂停',
    resumed: '任务已恢复',
    canceled: '任务已取消',
  },
  duplicateConfirm: {
    title: '已选择历史发送邮箱',
    message: '有 {count} 个已发送过冷邮件的邮箱仍被选中，确认再次发送？',
    confirm: '确认再次发送',
    back: '返回检查',
  },
  cancelConfirm: {
    title: '取消任务',
    message: '未开始发送的邮箱将被取消。',
    confirm: '确定取消',
    back: '返回',
  },
}

export default coldEmail
